import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { AppState } from 'src/app/store/app.states';
import { getUserInfo } from 'src/app/store/selector/selector';
import { take } from 'rxjs/operators';

declare var bootstrap: any;

@Component({
  selector: 'app-messagemodal',
  templateUrl: './messagemodal.component.html',
  styleUrls: ['./messagemodal.component.scss']
})
export class MessagemodalComponent implements OnInit {

  user:any
  constructor(public webApi: WebapiService,private store: Store<AppState>, private toastrService: ToastrService) {
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
    },1000)
  } 

  getThumbUrl(url : string){
    return  "assets/message_images/"+url
  }
  
  getUserData(){
    this.webApi.setLoader(true)

    this.store.pipe(select(getUserInfo),take(1)).subscribe(data=>{
      this.user = data
      this.webApi.setLoader(false)
    },error=>{
      this.webApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
    // this.webApi.getUserData().subscribe((data: any) => {
    //   if(data.success){
    //     this.user=data.data
    //   }else{
    //     this.toastrService.error(data.message);
    //   }
    // },
    // error => {
    //   this.toastrService.error("unable to handle response");
    // });
  }
  
}
